import Community from "../components/Home/Community";
import FrouthSection from "../components/Home/FrouthSection";
import HeroSection from "../components/Home/HeroSection";
import HomeFooter from "../components/Home/HomeFooter";
import NewsUpdates from "../components/Home/NewsUpdates";
import Partners from "../components/Home/Partners";
import StorySection from "../components/Home/StorySection";
import React, { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import HomeMarketplace from "../components/Home/HomeMarketplace";
import VideoModal from "../components/Modals/VideoModal";
import { useUiState } from "../context/UiContext";
import ScrollToTopModal from "../components/Scroll/ScrollToTop";
import { StringParam, useQueryParam } from "use-query-params";

const HomePage = () => {
  const { ref: storySectionRef, inView: storySectionInView } = useInView();
  const { ref: otherSectionRef, inView: otherSectionInView } = useInView();
  const [showVideo, setShowVideo] = useState(false);
  
  const {
    state: { isScrolledToStory }, //context to set scroll position for mobile navbar background
    actions: {
      setIsScrolledToStory,
    },
  } = useUiState();

  useEffect(() => {
    setIsScrolledToStory(storySectionInView)
  },[storySectionInView])

  return (
    <div className="bg-[#EEECE8]">
      <div
        className={
          storySectionInView
            ? "sticky top-[-78rem] sm:top-[-100rem] 2xl:top-[-88rem]"
            : ""
        }
      >
        <HeroSection />
      </div>
      <div
        className={
          storySectionInView
            ? "sticky top-[-50vh] sm:top-[-50vh] 2xl:top-[-20vh]"
            : ""
        }
      >
        <StorySection storySectionRef={storySectionRef} showVideo={() => setShowVideo(true)}/>
      </div>
      <div
        className={storySectionInView ? "relative" : ""}
        ref={otherSectionRef}
      >
        <FrouthSection />
        {/* <NewsUpdates /> */}
        <HomeMarketplace />
        <Partners />
        <Community />
        <HomeFooter />
        <ScrollToTopModal/>
      </div>
      <VideoModal isVisible={showVideo} onClose={() => setShowVideo(false)} />
    </div>
  );
};

export default HomePage;
